import React from 'react'
import Price_Icon from '../imageSrc/priceTag.png'
import './priceTagPage.css'

class Price_Tag extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            borderWidth:0 + 'px',
            borderStyle:'none',
            borderColor:'#F0C673'
        };
    }
    //
    // componentDidMount(){
    //     this.setState({
    //         borderWidth:this.props.selected?1 + 'px':0 + 'px',
    //         borderStyle:this.props.selected?'dashed':'none',
    //         borderColor:'#F0C673',
    //     })
    // };

    addSelectStateAndRequestVipBarCode = () => {
        this.props.requestBarCode(this.props.priceId,this.props.index);
    };

    render(){
        let borderWidth = this.props.selected?1 + 'px':0 + 'px';
        let borderStyle = this.props.selected?'dashed':'none';
        let borderColor = '#F0C673';
        return(
            <div className='div_background_style' onClick={this.addSelectStateAndRequestVipBarCode} style={{borderWidth:borderWidth,borderStyle:borderStyle,borderColor:borderColor}}>
                <p className='price_style'>{this.props.price}</p>
                <p className='vip_type_style'>{this.props.vipType}</p>
                <div className='vip_intro_text'>
                    {this.props.intro}
                </div>
            </div>
        );
    }
}

export default Price_Tag